export const client = {
    name: '',
    email: '',
    primaryPhone: '',
    owner: '',
    account: '',
    type: 'CLIENT',
    status: 'ACTIVE',
}
